import {
  AddOn,
  Vendor,
} from 'src/app/shared/models/database-models/SaveMyPurchase.model';
import {
  MaterialGroup,
  MaterialSubGroup,
} from 'src/app/shared/models/database-models';
import { DropDownOptions } from 'src/app/shared/models/app-models';
import { SelectOption } from 'src/app/modules/mypurchase-form/item-vendor/item-list/add-item/item-budget/item-budget.component';
import { ExcoBoardDocumentRecord } from 'src/app/shared/models/app-models/ExcoBoardDocument.model';
import { BlanketPurchaseRecord } from 'src/app/shared/models/app-models/BlanketPurchaseDocument.model';
import { TaggedGroups } from 'src/app/modules/mypurchase-form/rfs/tag-item-vendor.service';

export interface MyPurchaseForm {
  generalForm: GeneralForm;
  ItemList: IItemToRequest[];
  TenderItem?: TenderItemFormI;
  VendorsToSource: Vendor[];
  WoCReason: WOCReason | null;
  DoTPReason: DOTPReason | null;
  DOTPReasonId: string | null;
  isProjectRORequired: boolean;
  documentNo: string | null;
  parentDocumentNo: string | null;
  documentStatusId: number;
  documentStatus: string | null;
  RFQDeadline: number;
  documentSubStatusId: number | null;
  documentSubStatus: string | null;
  createdBy: string | null;
  Type: string;
  Env: string;
  CreatedOn?: Date;
  optionToPurchase?: AddOn[] | undefined;
  TenderStartDate?: Date | null;
  TenderEndDate?: Date | null;
  TenderStartTime?: string | null;
  TenderEndTime?: string | null;
  PurchaseTypeId: number | null;
  RO?: boolean | null
  CE?: string | null;
  TenderDocumentNumber: string | null;
  WOCFileReferenceNumber: string | null | undefined;
  WOCJustification: string | null | undefined;
  WOCId: string | null;
  DOTPJustification: string | null | undefined;
  DOTPId: string | null;
  isRFS?: boolean;
  isRFSEnabled?: boolean;
  PDPComplianceItemNumbers?: string | null;
  DOTPRemarks: string | null | undefined;
  TaggedGroups?: TaggedGroups['taggedGroups'] | null;
  ExchangeRateLock: boolean;
  rfqSummaryButton: boolean;
}

export interface IItemToRequest {
  AddItems: IAddItem;
  ItemPrice: IItemPrice;
  BudgetAllocation: IBudgetAllocForm[];
  isDeleted: boolean;
  Strikethrough: boolean;
  AddOnFeature?: AddOn[] | undefined;
}

export interface GeneralForm {
  RO: DropDownOptions;
  internal: DropDownOptions;
  external: DropDownOptions;
  preApproved: DropDownOptions;
  areExcoBoardDocumentsAttached: DropDownOptions;
  excoBoardDocumentArray: ExcoBoardDocumentRecord[] | null;
  reasonForNotUsingRFQ: DropDownOptions;
  blanketPurchaseType: DropDownOptions;
  blanketPurchaseDocumentArray: BlanketPurchaseRecord[] | null;
  purpose: string;
  purchaseTitle: string | null;
  typeOfRequisition: DropDownOptions;
  requisitionOthers: string | null;
  permissibleReason: DropDownOptions;
  otherPermissibleReasons: string | null;
  isDIRP: boolean | null;
}

export interface WOCReason {
  id: string;
  content: string;
  tooltips: string;
  code: string;
  isWOCRequired: boolean;
  isBlanket: boolean;
  hasFile?: boolean
}

export interface DOTPReason {
  id: string;
  Reason: string | null;
  Remarks: string;
  code: string;
}

export interface VendorTagging {
  id: number;
  vendorNumber: string[];
  status: number | null;
}

export interface TaggedVendors {
  Name: string;
  VendorNumber: number;
}

export interface IAddItem {
  PurchaseItemId: number | null;
  itemId: number;
  displayItemNumber: number;
  PartModelNumber: string;
  SMLReasonId: DropDownOptions | null;
  isCOTS: DropDownOptions | null;
  ItemDescription: string;
  PlannedDeliveryDate: Date;
  BrandOEMName: DropDownOptions | null;
  BrandOEMNameCustom?: string | null;
  MaterialGroupId: MaterialGroup | null;
  MaterialSubGroupId: MaterialSubGroup | null;
  PurchaseExecutive: string | null;
  WorkmanshipId: DropDownOptions | null;
  CriticalityId: DropDownOptions | null;
  isSingleBudget: boolean;
  SourcingStatusId: number | null;
  TaggedVendors: any | null;
  ReferenceId: number | null;
  IsGEWCA?: boolean | null;
  IsExemptedAOR: boolean | null;
  RestrictedITProductPolicy: string | null;
  AnnualMaintenanceCost: string | null;
  EstimatedUsageId: EstimatedAsset | null;
  IsSupportingNonFundingProject: boolean | null;
  SupportingInformation: string | null;
  IsAdditionalSpaceRequired: boolean | null;
  IsSML: boolean | null;
}

export interface EstimatedAsset {
  EstimatedUsageId: number,
  Name: string
}
export interface IItemPrice {
  UnitOfMeasurement: DropDownOptions;
  Quantity: number;
  UnitsPerQuantity: number;
  Currency: DropDownOptions;
  UnitPrice: number;
  ExchangeRate:number;
}

export interface IBudgetAllocForm {
  iBudgetId: number;
  BudgetItemId: number | null;
  Quantity: number | null;
  BudgetType: DropDownOptions;
  CostCentre: DropDownOptions | null;
  GLAcc: DropDownOptions | null;
  OrderNo: DropDownOptions | null;
  Percentage: number | null;
  FundCentre: DropDownOptions | null;
  ProjectBudget: DropDownOptions | null;
  BudgetExpenditureUsage: SelectOption | null;
  BudgetFrequencyUsage: SelectOption | null;
  ProjectCode: DropDownOptions | null;
  PurchaseItemNo: number | null;
  displayPurchaseItemNumber: number | null;
  ApprovingOfficer: string | null;
  isDeleted: boolean;
  Strikethrough: boolean,
  wbsElement?:string,
  FinancialYear?: string | null;
  EndFinancialYear?: string | null;
  aorAmount? : number;
}

export interface BudgetAllocationSummary {
  id: string;
  displayPurchaseItemNumber: string;
  budgetId: string;
  totalAmount: number;
  percentage: number;
  budgetType: string;
  costCentre: string;
  glAccount: string;
  costCentreId?: string;
  glAccountId?: string;
  orderNo: string;
  fundCentre: string;
  budgeted: string;
  reccurent: string;
  projectBudget: string;
  aorExemptedAmount: number;
  aorAmount: number;
  projectCode: string;
  personnel: DropDownOptions | string | undefined;
  personnelOptions: DropDownOptions[] | undefined;
  Strikethrough: boolean,
  wbsElement?:string;
  FinancialYear?: string | null;
  EndFinancialYear?: string | null;
}

export interface FormStatus {
  documentStatusId: number;
  documentSubStatusId: number | null;
  createdBy: string | null;
  CreatedOn: Date;
}

export interface TenderItemFormI {
  DeliveryAddress: DropDownOptions | undefined;
  TargetScheduleDate: string | null;

  PleaseSpecify?: string;
}

export interface TenderDate {
  StartDate: Date | null;
  EndDate: Date | null;
  StartTime: string | null;
  EndTime: string | null;
}
